import { render, staticRenderFns } from "./photoSee.vue?vue&type=template&id=ef690728&scoped=true&"
import script from "./photoSee.vue?vue&type=script&lang=js&"
export * from "./photoSee.vue?vue&type=script&lang=js&"
import style0 from "./photoSee.vue?vue&type=style&index=0&id=ef690728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef690728",
  null
  
)

export default component.exports